import { Link } from 'react-router-dom';
import { TarjetaComunicadoProps } from '../../interfaces/comunicadosInterfaces';
import './TarjetaComunicado.scss';

export const TarjetaComunicado = ({ comunicado }: TarjetaComunicadoProps) => {
  return (
    <>
      <div
        className="tarjeta-comunicado"
        style={{ background: `url('${comunicado.urlImagenHome ? comunicado.urlImagenHome : comunicado.urlImagenPortada}')` }}
      >
        <div className="resumen-comunicado p-3">
          <div className="h5 titulo">{comunicado.titulo}</div>
          <div className="descripcion">{comunicado.descripcion}</div>
          <div className="accion">
            <Link to={'/vista-comunicado/' + comunicado.comunicado_id}>
              Ver más...
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
